<script lang="ts" setup>

	import {useI18n} from 'vue-i18n';
	import {computed} from 'vue';
	import {useRelatedCustomersStore} from '@/store/related.customers.store.ts';

	const emit = defineEmits(['on-toggle-shopping-cart']);

	const props = defineProps<{
		amountOfWeeks: number;
		selectedCustomerId?: string | null;
	}>();

	const {t} = useI18n();

	const relatedCustomersStore = useRelatedCustomersStore();

	const relatedCustomer = computed(() => {
		return relatedCustomersStore.relatedCustomers
			.find(customer => customer.customerId === props.selectedCustomerId) || null;
	});

	const toggleShoppingCart = () => emit('on-toggle-shopping-cart');

</script>

<template>
	<div :class="[amountOfWeeks === 0 ? 'shoppingcart-empty' : '']"
	     class="shoppingcart__toggle-on">
		<button @click.prevent="toggleShoppingCart">
			<span v-if="relatedCustomer?.customerId && relatedCustomer.name" class="shoppingcart-customer-name">
				{{ relatedCustomer.name }} - {{ relatedCustomer.customerId }}
			</span>

			<span class="shoppingcart-myorder--inner">
				<span class="shoppingcart-icon">
					<svg height="15">
						<use xlink:href="/assets/images/build/svg-sprite.min.svg#shopping-cart"></use>
					</svg>
				</span>

				{{ t('shoppingcart.open.button.text.beforeamount') }}
				<span class="shoppingcart-amount">{{ amountOfWeeks }}</span>
				{{ t('shoppingcart.open.button.text.afteramount', amountOfWeeks) }}
			</span>
		</button>
	</div>
</template>

<style scoped>
	.shoppingcart-customer-name {
		display: block;
	}
</style>
